import React, { useMemo } from 'react';
import { OptionKey, SelectDropdown } from '@common-fe/common-fe';

import { ALL_OPTION_KEY } from '@/common/constants';
import { useSelectAllHandler } from '@/modules/core';
import { ACCOUNT_STATUS_OPTIONS } from '@/modules/Reports/report.types';

interface Props {
  testId?: string;
  values: OptionKey[];
  disabled?: boolean;
  onChangeValues: (value: OptionKey[]) => void;
}
const CIPAccountStatusSelector: React.FC<Props> = ({
  testId = 'cip-account-status_selector',
  disabled,
  values,
  onChangeValues,
}) => {
  const currentValue = useMemo(() => {
    if (!values.length && !disabled) {
      return [ALL_OPTION_KEY];
    }
    return values;
  }, [disabled, values]);

  const handleChangeValue = useSelectAllHandler(values, onChangeValues);

  return (
    <SelectDropdown
      key="cip-account-status_selector"
      ellipsisMode
      disabled={disabled}
      activeTitle
      testId={testId}
      options={ACCOUNT_STATUS_OPTIONS}
      values={currentValue}
      onChangeValues={handleChangeValue}
      prefix="Account Status"
      id="cip-account-status_selector"
      name="cip-account-status_selector"
      allMode
    />
  );
};

export default CIPAccountStatusSelector;
